// Shared product data consumed by all presentational components.
const product = {
  name: "Aurora Sound Lamp",
  price: "$89.99",
  description:
    "A smart ambient lamp with synchronized sound-reactive lighting and app-controlled scenes for your desk or bedside.",
  image:
    "https://images.unsplash.com/photo-1519710164239-da123dc03ef4?auto=format&fit=crop&w=900&q=80",
};

export default product;
